import { useQuery } from '@tanstack/react-query';
import { api, type MeResponse } from './api';

export function useMe(partnerId = 'aws') {
  return useQuery<MeResponse>({
    queryKey: ['me', partnerId],
    queryFn: () => api.me(partnerId),
    staleTime: 5 * 60_000,
  });
}
